import { ReactNode } from "react";
import { InteractionType, EndSessionRequest } from "@azure/msal-browser";
import { MsalAuthenticationTemplate } from "@azure/msal-react";
import { loginRequest } from "./authConfig";
import LocalAuthLogin from "./LocalAuthLogin";
import { useSomaAuth } from "./SomaAuthContext";

interface IAuthWrapperProps {
  children: ReactNode;
}

const AuthWrapper = ({ children }: IAuthWrapperProps) => {
  const { currentAccount, currentLocalUser, isLocalAuthEnabled, msalInstance } = useSomaAuth();

  if (isLocalAuthEnabled) {
    if (!currentLocalUser) {
      return <LocalAuthLogin />;
    }

    return <>{children}</>;
  }

  // Check if this is a forgot password token without the required enriched claims
  if (currentAccount?.idTokenClaims?.["isForgotPassword"] === true) {
    msalInstance?.logoutRedirect({
      postLogoutRedirectUri: "/",
    } as EndSessionRequest);
    return null;
  }

  return (
    <MsalAuthenticationTemplate
      interactionType={InteractionType.Redirect}
      authenticationRequest={loginRequest}
    >
      {children}
    </MsalAuthenticationTemplate>
  );
};

export default AuthWrapper;
